import { Component, inject } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dialog-free-tier',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, TranslateModule],
  templateUrl: './dialog-free-tier.component.html',
  styleUrls: ['./dialog-free-tier.component.scss'],
})
export class DialogFreeTierComponent {
  readonly dialogRef = inject(MatDialogRef<DialogFreeTierComponent>);

  onGoToForm() {
    this.dialogRef.close('form');
  }
}
